export function isLoginSuccess(response) {
  return !!(response && response.login && response.status !== 'fail');
}
